<template>
  <div class="setting-cost-matrix">
    <div class="toolbar">
      <div class="btns">
        <button type="button" class="btn btn-outline-black w180" @click="editRecord(-1)">+ New Record</button>
      </div>

      <div class="filters">
        <div class="input-search">
          <input type="text" name="s" class="form-control" placeholder="SEARCH MATRIX..." v-model="keyword" @change="doPaging(1)">
        </div>
        <v-select v-model="ftCategory" :options="allCategories" class="ft-category" :reduce="item => item.id"
                  label="name" :searchable="false" placeholder="ALL CATEGORIES"></v-select>
        <v-select v-model="ftSellBasis" :options="sellBasisOpts" class="ft-sell-basis" :reduce="item => item.code"
                  label="name" :searchable="false"  placeholder="ALL SELL BASIS"></v-select>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>CATEGORY</th>
            <th>TYPE/DETAILS</th>
            <th>SELL BASIS</th>
            <th>COST</th>
            <th>TIER 1 SELL</th>
            <th>TIER 2 SELL</th>
            <th>TIER 3 SELL</th>
            <th>TIER 4 SELL</th>
            <th width="100" class="text-right"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in allRecords" :key="index">
            <td>
              <a class="black" href="javascript:;" @click="editRecord( index )">{{ record.category.name }}</a>
            </td>
            <td>{{ record.description }}</td>
            <td>{{ record.sell_basis | statusToUCWords }}</td>
            <td>{{ record.cost }}</td>
            <td>{{ record.sell_tier1 }}</td>
            <td>{{ record.sell_tier2 }}</td>
            <td>{{ record.sell_tier3 }}</td>
            <td>{{ record.sell_tier4 }}</td>
            <td align="right">
              <a href="javascript:;" class="icon-trash" v-tooltip="'Delete record'" @click="confDelete( index )"></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="hasFilters && allRecords.length == 0" class="alert alert-warning">
      No records found
    </div>

    <div class="d-flex justify-content-between">
      <div class="actions d-flex">
        <template v-if="checkedIds.length > 0">
          <select class="form-control mr-2" v-model="bulkAction">
            <option value="">- Bulk action -</option>
            <option value="delete">Delete selected items</option>
          </select>
          <button type="button" class="btn btn-info" :disabled="bulkAction == ''" @click="doBulkAction">Action</button>
        </template>
      </div>
      <pagination :total-pages="totalPages" :current-page="currentPage"
        @goto-page="doPaging"></pagination>
    </div>

    <modal-edit-cost-matrix v-model="showModalEdit" :record="activeRecord" @cost-matrix-saved="onRecordSaved" @close-modal="onCloseModal"></modal-edit-cost-matrix>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ServiceCostmatrix from '@/services/costmatrix'
import ModalEditCostMatrix from './ModalEditCostMatrix'

export default {
  components: {
    ModalEditCostMatrix,
  },
  data () {
    return {
      showModalEdit: false,
      state: 'loading',
      keyword: '',
      activeIndex: -1,
      ftCategory: '',
      ftSellBasis: '',
      totalItems: 0,
      currentPage: 1,
      totalPages: 0,
      allRecords: [],
      checkedIds: [],
      bulkAction: '',
    }
  },
  watch: {
    ftCategory: function () {
      this.doPaging(1);
    },
    ftSellBasis: function () {
      this.doPaging(1);
    }
  },
  computed: mapState({
    allDepartments: state => state.option.departments,
    allCategories: state => state.option.costCategories,
    sellBasisOpts: state => state.option.sellBasisOpts,
    activeRecord () {
      let self = this;
      return self.allRecords[self.activeIndex] ? self.allRecords[self.activeIndex] : null;
    },
    hasFilters () {
      let self = this;
      return self.ftCategory != '' || self.ftSellBasis != '' || self.keyword != '';
    }
  }),
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      this.showModalEdit = false;
      self.getRecords();
    },
    editRecord ( index ) {
      let self = this;
      self.activeIndex = index;
      self.showModalEdit = true;
    },
    onRecordSaved ( record ) {
      let self = this;
      if(self.activeIndex != -1)
        self.allRecords.splice( self.activeIndex, 1, record );
      else
        self.allRecords.unshift( record );
      self.activeIndex = -1;
      self.$store.dispatch( 'SET_COSTS', self.allRecords );
    },
    onCloseModal(){
      this.activeIndex = -1;
      this.showModalEdit = false;
    },
    confDelete ( index ) {
      let self = this, item = self.allRecords[index];
      self.$dialog
        .confirm('Are you sure you want to delete <strong>' + item.category.name + '/' + item.description + '</strong> record?', {
          html: true,
          loader: true,
          okText: "Yes, I'm sure",
          cancelText: "Cancel",
        })
        .then(dialog => {
          ServiceCostmatrix.delete(item.id, (data) => {
            dialog.close();
            if(data.status == 'FAILED'){
              self.$notify({
                type: 'error',
                text: data.error
              });
            }else{
              self.allRecords.splice(index, 1);
              self.$store.dispatch( 'SET_COSTS', self.allRecords );
              self.$notify({
                type: 'success',
                text: 'Cost matrix record has been deleted'
              });
            }

          });
        })
        .catch(() => {})
      ;
    },
    doViewAll () {
      let self = this;
      self.currentPage = 1;
      self.keyword = '';
      self.ftCategory = '';
      self.ftSellBasis = '';
      self.getRecords();
    },
    doPaging ( page ) {
      let self = this;
      self.currentPage = page;
      self.getRecords();
    },
    getRecords () {
      let self = this,
        params = {
          page: self.currentPage,
        };

      if ( self.ftCategory !== '' ) {
        params.category_id = self.ftCategory;
      }
      if ( self.ftSellBasis !== '' ) {
        params.sell_basis = self.ftSellBasis;
      }
      if ( self.keyword !== '' ) {
        params.kw = self.keyword;
      }

      self.state = 'loading';
      ServiceCostmatrix.getAllRecords(params, resp => {
        self.state = 'loaded';
        self.allRecords = resp.data;
        self.totalPages = resp.last_page;
        self.totalItems = resp.total;
        self.checkedIds = [];
        self.$store.dispatch( 'SET_COSTS', self.allRecords );
      });
    },
    log(message){
      window.console.log(message);
    }
  }
}
</script>
